import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ViewHospitalPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('t');
    const userData = searchParams.get('u');
    const impersonatedBy = searchParams.get('by');

    if (!token || !userData) {
      navigate('/hospitals');
      return;
    }

    try {
      const currentToken = localStorage.getItem('token');
      const currentUser = localStorage.getItem('user');
      if (currentToken && currentUser) {
        localStorage.setItem('original_admin_token', currentToken);
        localStorage.setItem('original_admin_user', currentUser);
      }

      const user = JSON.parse(atob(userData));
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('impersonating', 'true');
      localStorage.setItem('impersonated_by', impersonatedBy || '');
      localStorage.setItem('impersonated_hospital', user.institution_name || '');

      navigate('/hospital/reports', { replace: true });
    } catch (e) {
      console.error('Impersonation failed:', e);
      navigate('/hospitals');
    }
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Loading hospital dashboard...</p>
      </div>
    </div>
  );
};

export default ViewHospitalPage;
